<template>
<ValidationObserver ref="observer">
  <form ref="add_service_master_form" @submit.prevent="addParking">
    <md-card>
      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          <span style="color:brown">Add Parking</span>
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Parking Code</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="category" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Parking Category</label>
                <md-select v-model="parking_line_id" @md-selected="onChangeServiceEstimate($event)" required>
                <md-option v-for="option in options_line" :key="option.value" :value="option.id">
                  {{ option.parking_line_name }}
                </md-option>
              </md-select>
                <validation-error :errors="apiValidationErrors.service_master_code" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Service Category</span><span style="color:red">*</span>
            </label> -->
              <validation-provider rules="vehicle" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Vehicle</label>
                <md-input v-model="parking_line_vehicle_plate_no" required/>
                <md-button :disabled="!parking_line_vehicle_plate_no" class="md-icon-button md-round md-info md-dense" v-on:click="findVehiclePlatNo()"><md-icon >search</md-icon></md-button>
                <validation-error :errors="apiValidationErrors.service_master_category_id" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
          </div>

          <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Vehicle No</label>
                  <md-input v-model="parking_vehicle_door_text" disabled />
                  <!-- <md-button style="background-color:green;" class="md-icon-button md-round md-info md-dense" v-on:click="findVehicle">
                    <md-icon >search</md-icon>
                  </md-button> -->
                  <validation-error
                    :errors="apiValidationErrors.parking_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

        
      </md-card-content>
      <br>
      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <md-button class="md-dense"  @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import { extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import formMixin from "@/mixins/form-mixin";
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);
// validasi pesan error required field
extend('vehicle', {
  ...required,
  message: 'Vehicle field is required'
});
extend('code', {
  ...required,
  message: 'Parking Code field is required'
});
export default {
  name: "add-parking",

  props: {
    data: Object
  },

  components: {ValidationError, ValidationObserver},

  mixins: [formMixin],

  data: () => ({
    parking_line_id: null,
    parking_line_vehicle_plate_no: null,
    options_line: null,
    options_vehicle_list:null,
    dataValid: false,
    parking_vehicle_door_text: null
  }),

  created() {
    this.onOpen();
  },
  methods: {

    async onOpen(){
      await this.$store.dispatch("workshop_parking_line/quota")
      this.options_line = await this.$store.getters["workshop_parking_line/list"]
      
    },

    setData(data){
      this.parking_line_vehicle_id = data.id
      // this.checker.vehicle_plate_no = data.vehicle_plate_no
      this.parking_vehicle_door_text = data.vehicle_door_no
      this.dataValid = true

    },

    async findVehiclePlatNo(){
      var query = {}
      query.filter = {parking_line_list:this.parking_line_vehicle_plate_no}
      await this.$store.dispatch("workshop_vehicle/list", query)
       var data = await this.$store.getters["workshop_vehicle/list"];
      if(Object.keys(data).length!=0){
           this.setData(data[0])
       }
       else{
         this.swalFindError()
         this.dataValid = false
          this.parking_line_vehicle_plate_no = null
       }
        //  this.swalFindError()
        //  this.dataValid = false
        //   this. checker.id = data.id
        //   this.checker.vehicle_plate_no = data.vehicle_plate_no
        //   this.checker.vehicle_door_no = data.vehicle_door_no
       
    },

    swalFindError(){
      this.parking_line_vehicle_plate_no = null,
      this.parking_vehicle_door_text = null
      Swal.fire({
          icon: 'error',
          title: 'Not Found',
          text: 'Data kendaraan tidak ditemukan',
        })
    },

    // fungsi tombol direct ke list view table
    backtoList(id) {
      this.$router.replace({ name: 'List Parking', params: { id: id } })
    },
    
    // validasi untuk add data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will Saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, saved it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addParking()
        }
      });
    },

    // fungsi add data
    async addParking() {
      const data = {
        type: "workshop_parkings",
        parking_line_id: this.parking_line_id,
        parking_line_vehicle_id: this.parking_line_vehicle_id,
      }
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_parking/add", data);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // kembali ke list Parking
        await this.$router.push({name: 'List Parking'});
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
        "alerts/error",
        "Oops, something went wrong"
        );
        console.log(e.response.data.errors);
        this.setApiValidation(e.response.data.errors);
      }

    }
  }
};
</script>
<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>
